export default "__VITE_ASSET__axQNZxKT__"